import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=2c43bd70&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c43bd70')) {
      api.createRecord('2c43bd70', component.options)
    } else {
      api.reload('2c43bd70', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=2c43bd70&", function () {
      api.rerender('2c43bd70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wWRAnooEJZqu/JS/comp/offers.vue"
export default component.exports